export default [
    'primary_text',
    'short_description',
    'cover_image',
    'deactivated',
    'desireIds',
    'featured',
    'interestIds',
    'published',
    'sortorder',
    'tagIds',
    'title',
    'user_id',
    'video_url',
    'categoryIds',
    'content_type_id',
    'locked',
    'preview_video_url',
];
